// Function loadNavigator loads the Navigator class by dynamically importing the js on demand if needed

export function loadNavigator($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="Navigator"]');

	if(!$wg) {
		// console.info('Navigator: no widget found');
		return Promise.reject('Navigator widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-navigator-chunk" */ '../widgets/navigator').then(wg => {

		const { Navigator } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="Navigator"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new Navigator($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new Navigator($wg);
		}


	}).catch(error => error+'An error occurred while loading the Navigator widget');

}
